module.exports = __webpack_public_path__ + "static/media/seguro_vehiculo@2x.91a846f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/seguro_vehiculo@2x.jpg
// module id = 367
// module chunks = 0